import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import isEmpty from 'lodash/isEmpty';

import Config from 'config/config';


export interface DecodedToken {
    readonly iat: number;
    readonly exp: number;
    readonly roles: string[];
    readonly username: string;
}

export function instanceOfDecodedToken(object: any): object is DecodedToken {
    return 'username' in object && 'roles' in object;
}

export const OFFICE_TOKEN_STORAGE_KEY = 'IA_B_AT';
export const OFFICE_REFRESH_TOKEN_STORAGE_KEY = 'IA_B_RT';

const { app } = Config;

export class OfficeAuthToken {
    readonly decodedToken: DecodedToken = null;

    constructor(readonly token?: string) {
        // // we are going to default to an expired decodedToken
        // this.decodedToken = { username: '', site: {} as Site, iat: 0 };

        // then try and decode the jwt using jwt-decode
        try {
            // if (!token) {
            //     location.href = getLoginUrl(false, true);
            // }

            this.decodedToken = jwtDecode(token);

            // if (!this.isValid){
            //     location.href = getLoginUrl(false, true);
            // }
        } catch (e) {
            // location.href = getLoginUrl(false, true);
        }
    }

    static async storeToken(token: string, refreshToken: string) {
        const expirationDate = new Date();

        expirationDate.setTime(expirationDate.getTime() + 24 * 60 * 60 * 1000); // 1 day

        Cookies.set(OFFICE_TOKEN_STORAGE_KEY, token, {
            domain: Config.app.domain,
            // expires: expirationDate,
        });

        Cookies.set(OFFICE_REFRESH_TOKEN_STORAGE_KEY, refreshToken, {
            domain: Config.app.domain,
            // expires: expirationDate,
        });
    }

    static removeToken() {
        // remove token on this site
        Cookies.remove(OFFICE_TOKEN_STORAGE_KEY);
        Cookies.remove(OFFICE_REFRESH_TOKEN_STORAGE_KEY);

        Cookies.remove(OFFICE_TOKEN_STORAGE_KEY, { domain: window.location.hostname });
        Cookies.remove(OFFICE_REFRESH_TOKEN_STORAGE_KEY, { domain: window.location.hostname });

        Cookies.remove(OFFICE_REFRESH_TOKEN_STORAGE_KEY, {
            domain: app.domain,
        });

        // remove token on subdomain
        return Cookies.remove(OFFICE_TOKEN_STORAGE_KEY, {
            domain: app.domain,
        });
    }

    static getToken(): string {
        return Cookies.get(OFFICE_TOKEN_STORAGE_KEY);
    }

    static getRefreshToken(): string {
        return Cookies.get(OFFICE_REFRESH_TOKEN_STORAGE_KEY);
    }

    get getDecodedToken() {
        return this.decodedToken;
    }

    get authorizationString() {
        return `Bearer ${String(this.token)}`;
    }

    get expiresAt(): Date {
        return this.decodedToken?.exp && new Date(this.decodedToken.exp * 1000);
    }

    get isExpired(): boolean {
        return new Date() > this.expiresAt;
    }

    get isValid(): boolean {
        return !isEmpty(this.decodedToken) &&
                instanceOfDecodedToken(this.decodedToken) &&
                !isEmpty(this.decodedToken?.username);
    }
}
